import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseDraggableWidget } from '../Card';
import { getAsset, getEventsByAsset } from '../../../api';
import useAsync from '../../../hooks/useAsync';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { BaseList } from '../../Widgets/WidgetBase';
import { pluralize } from '../../helpers/functions';
import useModal from '../../../hooks/useModal';

const dateKey = {
	SKIPPED: 'estimatedDate',
	ESTIMATED: 'estimatedDate',
	SCHEDULED: 'scheduledDate',
	COMPLETED: 'completedDate',
	RENEW: 'date',
};

const TITLE = 'Events/Tasks';
const DESCRIPTION = 'Enter description here';
const CATEGORY = 'Blank Category';

const AssetUpcomingTasks = ({ title, isPreview, ...rest }) => {
	const [query, setQuery] = useState('');
	const { id } = useParams();

	const { open: isAddNewTaskModalOpen, setOpen: openAddNewTaskModal } =
		useModal('taskAdd');

	const { open: eventDetailsOptions, setOpen: openEventModal } =
		useModal('eventDetails');

	const navigate = useNavigate();

	const { value: item } = useAsync(getAsset, { defaultPayload: { id } });

	const {
		value: upcomingEvents,
		status: isLoadingEvents,
		error: hasError,
	} = useAsync(getEventsByAsset, {
		defaultPayload: {
			startDate: moment().startOf('day').toDate(),
			status: ['ESTIMATED', 'SCHEDULED'],
			assetId: id,
		},
		silent: true,
	});

	if (isPreview) {
		return (
			<BaseDraggableWidget
				title={TITLE}
				category={CATEGORY}
				description={DESCRIPTION}
				{...rest}
				isPreview={true}
			/>
		);
	}

	const isEmpty =
		upcomingEvents?.length === 0
			? { isEmpty: true, flexCenter: true, skipIcon: true }
			: {};
	const isError = !!hasError ? { isError: true, flexCenter: true } : {};

	return (
		<BaseDraggableWidget
			title={TITLE}
			widgetProps={{
				isLoading: isLoadingEvents === 'pending',
				...isError,
				...isEmpty,
				isEmptyMessage: 'No upcoming tasks',
				additonalMenuItems: [
					{
						name: 'Open new task',
						onClick: () =>
							openAddNewTaskModal({ entityType: 'asset', entityId: id }),
					},
				],
			}}
			{...rest}
		>
			<div>
				{upcomingEvents?.length ? (
					<h2 className="text-xs font-light mb-4 text-gray-500 border-t border-b py-3">{`You have ${
						upcomingEvents?.length
					} ${pluralize(upcomingEvents?.length, 'event', 'events')}`}</h2>
				) : null}
				<BaseList
					items={
						upcomingEvents?.length
							? upcomingEvents
									?.sort(
										(a, b) =>
											new Date(a[dateKey[a.status]]) -
											new Date(b[dateKey[b.status]])
									)
									?.map((event) => {
										const eventDate = moment(
											event?.scheduledDate || event?.estimatedDate
										);

										return {
											children: (
												<div
													className="grid grid-cols-2 gap-x-6 flex-1 py-2 cursor-pointer"
													onClick={() => openEventModal({ id: event?.id })}
												>
													<div className="text-gray-500">
														{event?.scheduledDate
															? moment().isSame(eventDate, 'day')
																? event?.scheduledDateEnd
																	? `Today at ${eventDate?.format('h:mmA')}`
																	: 'Today'
																: moment()
																		.add(1, 'day')
																		.isSame(eventDate, 'day')
																? 'Tomorrow'
																: eventDate.format('dddd, MMM Do')
															: `Estimated: ${eventDate.format(
																	'ddd, MMM Do, YYYY'
															  )}`}
													</div>
													<div>{event?.title}</div>
												</div>
											),
										};
									})
							: []
					}
				/>
			</div>
		</BaseDraggableWidget>
	);
};

export default AssetUpcomingTasks;
